export const en_US = {
  translation: {
    add_to_cart: "Add article to cart",
    save: "Save",
    load: "Load article",
    title: "Configuration",
    type_key: "Type key",
    start: "Start",
    generate_document: "Create data sheet",
    sap_button: "Create article in SAP",
    cad_button: "Create CAD data",
    drawing_button: "Create drawing data",
    reset_configuration: "Reset configuration",
    show_additional_information: "Show additional information",
    sap_title: "SAP",
    close_configuration_button: "Close",
    no_results_found: "No results found",
    newId_button: "Create new GUID",
    load_configuration_dialog: {
      title: "Load configuration – Set search parameters",
      cancel: "Cancel",
      search: "Search",
      start_date: "Creation date from",
      end_date: "to",
      guid: "GUID",
      material_number: "Material number",
      order_code: "Order code",
      creator: "Creator",
      description: "Description",
      info_artikel: "Info article",
      short_text: "Short text",
      version: "Version",
      status: "Status",
      update_user: "Updated by",
      createdDate: "Creation date",
      saved_records: "Saved records",
      back: "Back",
      open: "Open",
      rows_per_page: "Rows per page:",
    },
    error: {
      ERROR_LOAD_DATA_ERROR: "(LOAD) failed (data incorrect or incomplete)",
      ERROR_SAVE_DATA_ERROR: "(SAVE) failed (data incorrect or incomplete)",
      ERROR_LOAD_ID: "ID to load not found",
      ERROR_LOAD_ID_CONFIG: "Error from configurator when loading a project",
      ERROR_LOADSTART_CONFIG: "Error from configurator at start",
      ERROR_MISSING_VALUES:
        "General error message if validation of frontend data fails",
      ERROR_COOKIE_SERVICE_INITIAL: "Cookie service initialization failed",
      ERROR_COOKIE_GENERAL: "Error in cookie service",
      ERROR_TOKEN_NOT_FOUND: "Token not found",
      ERROR_ID_BLOCKED: "Item is being edited, changes not possible",
      ERROR_DB_SAVE: "Error while saving data to the database",
      ERROR_LOAD_VALID: "Loading configuration failed, data invalid",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK: "ID not found, SAP check failed",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "No material number found for the ID from the shop ID",
      ERROR_DELETE_CONFIGURATION: "Error deleting configuration",
      ERROR_DEFINITION_SECRET_JWT: "JWT definition missing",
      ERROR_PATH_NOT_DEFINED: "Path not defined",
      ERROR_BACKLINK_URL: "Backlink URL not defined",
      ERROR_POSITIONDATA_EMPTY: "Position data is empty",
      ERROR_SHOP_ID: "Shop ID not found",
      ERROR_CADBOXDATA_EMPTY: "No CAD box data found",
      ERROR_NONE_LOAD_ID_FOUND: "No ID to load found",
      ERROR_NONE_ACCEPTABLE_ID: "No acceptable ID found",
    },
    sap: {
      create_error: "Error during creation",
      create_success: "Successfully created",
    },
    session_expired: {
      title: "⚠️ Session was cancelled",
      text: "The session was terminated due to inactivity. Please restart the configurator.",
    },
    button: {
      save: "Save",
      cancel: "Cancel",
    },
  },
};

export default en_US;
